import React, { Component } from 'react';
import {
    Box,
    Divider,
    IconButton,
    MenuItem,
    TextField,
    Typography
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import { ViewCompact, List } from '@mui/icons-material';
import SingleFile from './SingleFile';
import i18n from 'i18next';

class MultipleUploadComponent extends Component {
    // files, handleFileUpload
    constructor(props) {
        super(props);

        this.state = {
            type: 'grid'
        };
    }

    renderAddFile() {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexBasis="content"
            >
                <IconButton
                    sx={{ marginX: 1 }}
                    onClick={(event) => this.fileUpload.click()}
                >
                    <AddIcon />
                    <input
                        type="file"
                        accept="*/*"
                        hidden
                        ref={(fileUpload) => {
                            this.fileUpload = fileUpload;
                        }}
                        onChange={(event) => this.props.handleFileUpload(event)}
                    />
                </IconButton>
            </Box>
        );
    }

    renderGridFiles(files) {
        return (
            <Box display="flex" flexWrap="wrap">
                {files.map((file, i) => {
                    const fieldFileType = this.props.fieldFileType;
                    const fileTypes = this.props.fileTypes;
                    return (
                        <Box m={1} key={i}>
                            <Box
                                flexBasis="content"
                                sx={{
                                    position: 'relative',
                                    width: 100,
                                    height: 100,
                                    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
                                    borderRadius: 1,
                                    marginBottom: 1
                                }}
                            >
                                <img
                                    width="100px"
                                    height="100px"
                                    style={{ borderRadius: '6px' }}
                                    src={file.url}
                                    alt="upload"
                                />
                                <IconButton
                                    sx={{
                                        "position": 'absolute',
                                        "padding": '1px',
                                        "top": 0,
                                        "right": 0,
                                        "zIndex": 1,
                                        "backgroundColor":
                                            'rgba(255, 255, 255, 0.9)',
                                        "borderRadius": '0 5px 0 6px',
                                        '&:hover': {
                                            backgroundColor:
                                                'rgba(225,225,225, 0.8)'
                                        }
                                    }}
                                    onClick={(event) =>
                                        this.props.onOpenPopover(event, file.id)
                                    }
                                >
                                    <MoreVertIcon />
                                </IconButton>
                            </Box>

                            {this.props.inputFileType && (
                                <TextField
                                    fullWidth
                                    select
                                    margin="dense"
                                    variant="outlined"
                                    label="File Type"
                                    value={file[fieldFileType]}
                                    onChange={(event) =>
                                        this.props.handleInput(event, file.id)
                                    }
                                >
                                    {fileTypes.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {i18n.t(`enums.${option}`)}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        </Box>
                    );
                })}
                {this.renderAddFile()}
            </Box>
        );
    }

    renderListFiles(files) {
        return (
            <Box display="flex" flexDirection="column" width="100%">
                {files.map((file, i) => (
                    <>
                        <SingleFile
                            key={i}
                            file={file}
                            fieldFileType={this.props.fieldFileType}
                            fileTypes={this.props.fileTypes}
                            onOpenPopover={this.props.onOpenPopover}
                            inputFileType={this.props.inputFileType}
                            handleInput={this.props.handleInput}
                        />
                        <Divider />
                    </>
                ))}
                <Box mt={2}>{this.renderAddFile()}</Box>
            </Box>
        );
    }

    render() {
        return (
            <>
                {this.props.files.length > 0 && (
                    <Box display="flex" justifyContent="flex-end">
                        <IconButton
                            onClick={(e) => this.setState({ type: 'grid' })}
                        >
                            <ViewCompact />
                        </IconButton>
                        <IconButton
                            onClick={(e) => this.setState({ type: 'list' })}
                        >
                            <List />
                        </IconButton>
                    </Box>
                )}
                <Box display="flex" alignItems="center" p={2} width="100%">
                    {this.props.files.length === 0 && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            align="center"
                        >
                            Please upload a file
                        </Typography>
                    )}

                    {this.state.type === 'grid'
                        ? this.renderGridFiles(this.props.files)
                        : this.renderListFiles(this.props.files)}
                </Box>
            </>
        );
    }
}

export default MultipleUploadComponent;
